module.exports = new __parcel__URL__("shop_other_button_inactive.7b86830c.png").toString();